import { defineMessage } from 'magpie-lib/models';
const publicApiAvailable = defineMessage({
  type: 'public-api-available'
});
const isPublicApiAvailable = defineMessage({
  type: 'is-public-api-available',
  reply: publicApiAvailable
});
export const publicApiAvailability = {
  publicApiAvailable,
  isPublicApiAvailable
};